import Agreement from 'client/components/entities/Agreement'
import Audio from 'client/components/entities/Audio'
import AudioNew from 'client/components/entities/Audio/AudioNew'
import BlogContentPlaceholder from 'client/components/entities/BlogContentPlaceholder'
import BlogPostContentPlaceholder from 'client/components/entities/BlogPostContentPlaceholder'
import BodyOld from 'client/components/entities/BodyOld'
import { BookingCalendar } from 'client/components/entities/BookingCalendar'
import Button from 'client/components/entities/Button'
import BlogPageBody from 'client/components/entities/blog-page-body'
import { BlogPostBody } from 'client/components/entities/blog-post-body'
import BlogPostLayoutBody from 'client/components/entities/blog-post-layout-body'
import { Body } from 'client/components/entities/body'
import ButtonNew from 'client/components/entities/button-new'
import Checkbox from 'client/components/entities/Checkbox'
import Column from 'client/components/entities/Column'
import ColumnOld from 'client/components/entities/Column/ColumnOld'
import ContentBox from 'client/components/entities/ContentBox'
import ContentBoxOld from 'client/components/entities/ContentBox/ContentBoxOld'
import Countdown from 'client/components/entities/Countdown'
import CountdownOld from 'client/components/entities/Countdown/CountdownOld'
import CustomerType from 'client/components/entities/CustomerType'
import Coupon from 'client/components/entities/coupon'
import CouponOld from 'client/components/entities/coupon-old'
import FacebookComments from 'client/components/entities/FacebookComments'
import Field from 'client/components/entities/field-new'
import FieldNew from 'client/components/entities/field-new/field-new'
import Headline from 'client/components/entities/Headline'
import Image from 'client/components/entities/Image'
import ImageNew from 'client/components/entities/Image/Image'
import InlineBody from 'client/components/entities/inline-body'
import LanguageSwitcher from 'client/components/entities/LanguageSwitcher'
import Menu from 'client/components/entities/Menu/Menu'
import NewBulletList from 'client/components/entities/NewBulletList'
import NewHorizontalLine from 'client/components/entities/NewHorizontalLine'
import OfferPrice from 'client/components/entities/OfferPrice'
import OfferThankYouOrderSummaryNew from 'client/components/entities/OfferThankYouOrderSummaryNew'
import OrderBumpOld from 'client/components/entities/OrderBump'
import PaymentButtonNew from 'client/components/entities/PaymentButton/PaymentButtonNew'
import PaymentMethods from 'client/components/entities/PaymentMethods'
import PricePlanCalculator from 'client/components/entities/PricePlanCalculator'
import PopupNew from 'client/components/entities/popup-new'
import { PriceElement } from 'client/components/entities/price-element'
import RawHtml from 'client/components/entities/RawHtml'
import Recaptcha from 'client/components/entities/Recaptcha'
import Row from 'client/components/entities/Row'
import ReadOnlyRow from 'client/components/entities/Row/components/ReadOnlyRow'
import ReadOnlyRowOld from 'client/components/entities/Row/ReadOnlyRowOld'
import RowOld from 'client/components/entities/Row/RowOld'
import RemotePopupBody from 'client/components/entities/remote-popup-body'
import Section from 'client/components/entities/Section'
import SectionOld from 'client/components/entities/Section/SectionOld'
import ShippingFees from 'client/components/entities/ShippingFees'
import StartTimer from 'client/components/entities/StartTimer'
import { SearchResults } from 'client/components/entities/search-results'
import TextNew from 'client/components/entities/Text/Text'
import TwitterTweetButton from 'client/components/entities/TwitterTweetButton'
import TwoStepPaymentForm from 'client/components/entities/TwoStepPaymentForm/TwoStepPaymentForm'
import OfferPriceNew from 'client/pages/offer/entities/OfferPrice'
import Product from 'client/pages/offer/entities/Product'
import { ColumnInterface } from 'common/components/entities/Column/types/ColumnInterface'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import { RowInterface } from 'common/components/entities/Row/types/RowInterface'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AgreementInterface } from 'common/types/entities/AgreementInterface'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { BlogPageBodyInterface } from 'common/types/entities/blog-page-body-interface'
import { BlogPostLayoutInterface } from 'common/types/entities/blog-post-layout-body-interface'
import { BodyInterface } from 'common/types/entities/body-interface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import CarouselInterface from 'common/types/entities/CarouselInterface'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import FaqInterface from 'common/types/entities/FaqInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import ProductEntityInterface from 'common/types/entities/ProductInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import { Form } from 'src/editor/shared/entities/form'
import { LoginButton } from 'src/editor/shared/entities/login-button'
import { RegistrationButton } from 'src/editor/shared/entities/registration-button'
import { Search } from 'src/editor/shared/entities/search'
import { WebsiteLayoutBody } from 'src/editor/shared/entities/website-layout-body'
import { WebsitePageBody } from 'src/editor/shared/entities/website-page-body'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { LoginButtonInterface } from 'src/shared/types/entities/login-button-interface'
import { RegistrationButtonInterface } from 'src/shared/types/entities/registration-button-interface'
import {
  WebsiteLayoutBodyInterface,
  WebsitePageInterface,
} from 'src/shared/types/website-entities'
import { LanguageSwitcherInterface } from '../../common/types/entities/LanguageSwitcherInterface'
import { RawHtmlInterface } from '../../common/types/entities/RawHtmlInterface'
import NewAgreement from '../components/entities/Agreement/Agreement'
import Carousel from '../components/entities/Carousel'
import ContentTable from '../components/entities/ContentTable'
import Faq from '../components/entities/Faq'
import NewLanguageSwitcher from '../components/entities/LanguageSwitcher/NewLanguageSwitcher'
import NewRawHtml from '../components/entities/RawHtml/NewRawHtml'
import Survey from '../components/entities/Survey'
import SurveyNew from '../components/entities/Survey/Survey'
import VideoNew from '../components/entities/VideoNew'
import BlogContentPlaceholderNew from './blog/entities/BlogContentPlaceholderNew'
import { ForgotPassword } from './custom-login/entities/ForgotPassword'
import CustomerTypeNew from './offer/entities/CustomerType'
import OrderBump from './offer/entities/order-bump'
import PaymentMethod from './offer/entities/PaymentMethod'

export type AdditionalProps = {
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export function createEmptyEntityElement() {
  return <div />
}

export default function createCommonEntityElement(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  const { type, id } = entity

  switch (type) {
    case structureTypes.BODY:
    case structureTypes.BLOG_POST_BODY:
    case structureTypes.BLOG_PAGE_BODY:
    case structureTypes.BLOG_POST_LAYOUT_BODY: {
      return (
        <BodyOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Body: {
      return (
        <Body
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as BodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPostBody: {
      return (
        <BlogPostBody
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as BodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPageBody: {
      return (
        <BlogPageBody
          entity={entity as BlogPageBodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPostLayoutBody: {
      return (
        <BlogPostLayoutBody
          entity={entity as BlogPostLayoutInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case structureTypes.SECTION: {
      return (
        <SectionOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Section:
      return (
        <Section
          entity={entity as SectionInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.ROW: {
      if (entity.isReadOnly) {
        return (
          <ReadOnlyRowOld
            //@ts-ignore @TODO harmonize interfaces
            entity={entity as OldEntityInterface}
            key={`entity-${id}`}
          />
        )
      }

      return (
        <RowOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          childIds={entity.childIds}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Row: {
      if (entity.isReadOnly) {
        return (
          <ReadOnlyRow entity={entity as RowInterface} key={`entity-${id}`} />
        )
      }
      return (
        <Row
          entity={entity as RowInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case structureTypes.COLUMN:
      return (
        <ColumnOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Column:
      return (
        //@ts-ignore @TODO harmonize interfaces
        <Column
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as ColumnInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Headline:
      return (
        <Headline
          entity={entity as HeadlineInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BulletList:
      return (
        <NewBulletList
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BookingCalendar:
      return (
        <BookingCalendar
          //@ts-ignore @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.IMAGE:
      return (
        <Image
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Image:
      return (
        <ImageNew
          entity={entity as ImageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew
          entity={entity as ButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LoginButton:
      return (
        <LoginButton
          entity={entity as LoginButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RegistrationButton:
      return (
        <RegistrationButton
          entity={entity as RegistrationButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.BUTTON:
    case structureTypes.PAYMENT_BUTTON:
      return (
        <Button
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.FORM_INPUT:
      return (
        <Field
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Field:
      return (
        <FieldNew
          entity={entity as FieldInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Form:
      return (
        <Form
          entity={entity as FormInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Popup:
      return (
        <PopupNew
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as PopupInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RemotePopupBody:
      return (
        <RemotePopupBody
          //@ts-ignore @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.InlineBody:
      return (
        //@ts-ignore @TODO harmonize interfaces
        <InlineBody entity={entity} key={`entity-${id}`} {...additionalProps} />
      )
    case EntityTypeEnum.Video:
      return (
        <VideoNew
          entity={entity as VideoInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.AUDIO:
      return (
        <Audio
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.CONTENT_BOX:
      return (
        <ContentBoxOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.PAYMENT_METHOD:
      return (
        <PaymentMethods
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.CUSTOMER_TYPE:
      return (
        <CustomerType
          //@ts-ignore @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.OFFER_PRICE:
      return (
        <OfferPrice
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPriceNew
          entity={entity as OfferPriceInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Product:
      return (
        <Product
          entity={entity as ProductEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.RAW_HTML:
      return (
        <RawHtml
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RawHtml:
      return (
        <NewRawHtml
          entity={entity as RawHtmlInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.ORDER_BUMP:
      return (
        <OrderBumpOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderBump:
      return (
        //@ts-ignore @TODO harmonize interfaces
        <OrderBump entity={entity} {...additionalProps} key={`entity-${id}`} />
      )
    case EntityTypeEnum.Checkbox:
      return (
        <Checkbox
          entity={entity as CheckboxInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.START_TIMER:
      return (
        <StartTimer
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.AGREEMENT:
      return (
        <Agreement
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderSummary:
      return (
        <OfferThankYouOrderSummaryNew
          entity={entity as EntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.COUNTDOWN:
      return (
        <CountdownOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Coupon:
      return (
        <Coupon
          key={`entity-${id}`}
          entity={entity as CouponInterface}
          {...additionalProps}
        />
      )
    case structureTypes.COUPON:
      return (
        <CouponOld
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.BLOG_POST_CONTENT_PLACEHOLDER:
      return (
        <BlogPostContentPlaceholder
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.BLOG_CONTENT_PLACEHOLDER:
      return (
        <BlogContentPlaceholder
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogContentPlaceholder:
      return (
        <BlogContentPlaceholderNew
          entity={entity as BlogContentPlaceholderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Menu:
      return (
        <Menu
          entity={entity as MenuInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.LANGUAGE_SWITCHER:
      return (
        <LanguageSwitcher
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LanguageSwitcher:
      return (
        <NewLanguageSwitcher
          entity={entity as LanguageSwitcherInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.TWO_STEP_PAYMENT_FORM:
      return (
        <TwoStepPaymentForm
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.TwitterTweetButton:
      return (
        <TwitterTweetButton
          entity={entity as TwitterTweetButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.SURVEY:
      return (
        <Survey
          //@ts-ignore @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Carousel:
    case structureTypes.CAROUSEL:
      return (
        <Carousel
          entity={entity as CarouselInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Faq:
      return (
        <Faq
          entity={entity as FaqInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PricePlanCalculator:
      return (
        <PricePlanCalculator
          entity={entity as PricePlanCalculatorInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PriceElement:
      return (
        <PriceElement
          //@ts-ignore @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResults
          //@ts-ignore @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    // case EntityTypeEnum.Search:
    //   return (
    //     //@ts-ignore @TODO harmonize interfaces
    //     <Search entity={entity} key={`entity-${id}`} {...additionalProps} />
    //   )
    case EntityTypeEnum.Text:
      return (
        <TextNew
          entity={entity as TextInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContentTable:
      return (
        <ContentTable
          entity={entity as ContentTableInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Survey:
      return (
        <SurveyNew entity={entity as SurveyInterface} {...additionalProps} />
      )
    case EntityTypeEnum.HorizontalLine:
      return (
        <NewHorizontalLine
          entity={entity as HorizontalLineInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Audio:
      return (
        <AudioNew
          entity={entity as AudioInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.FacebookComments: {
      return (
        <FacebookComments
          entity={entity as FacebookCommentsInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.OptInRecaptcha: {
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.Countdown: {
      return (
        <Countdown entity={entity as CountdownInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.CustomLoginForgotPassword: {
      return (
        <ForgotPassword
          entity={entity as CustomLoginForgotPasswordInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.CustomerType: {
      return (
        <CustomerTypeNew
          entity={entity as CustomerTypeInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.ContentBox: {
      return (
        <ContentBox
          entity={entity as ContentBoxInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.PaymentMethod: {
      return (
        <PaymentMethod
          entity={entity as PaymentMethodInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Comments:
      return <div />
    case EntityTypeEnum.ShippingFees:
      return (
        <ShippingFees
          entity={entity as ShippingFeesInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PaymentButton:
      return (
        //@ts-ignore @TODO harmonize interfaces
        <PaymentButtonNew
          entity={entity as PaymentButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Agreement:
      return (
        <NewAgreement
          entity={entity as AgreementInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteLayoutBody:
      return (
        <WebsiteLayoutBody
          entity={entity as WebsiteLayoutBodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsitePageBody:
      return (
        <WebsitePageBody
          entity={entity as WebsitePageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    default: {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`unknown type ${type} of entity id = ${id}`)
        return (
          <div>
            <i className="fas fa-bug" />
            <span> !!! INVALID ENTITY !!!</span>
          </div>
        )
      }

      return <div className="test" />
    }
  }
}
